import React from 'react';

import { ButtonProps } from '../../storyblocks-design-system/components/atoms/Button/types';
import { Button } from '../blocks/Button.builder';

export interface BottomCTAProps {
  text: string;
  href: string;
  target?: ButtonProps['target'];
  rel?: string;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
}

interface CTAButtonProps {
  show: boolean;
  cta?: BottomCTAProps;
  onClick?: () => void;
  className?: string;
}

const BottomCTAButton = ({
  show,
  cta,
  onClick,
  className = 'flex justify-center mt-12',
}: CTAButtonProps) => {
  if (!show || !cta?.text) return null;

  return (
    <div className={className}>
      <Button
        variant={cta.variant}
        size={cta.size}
        link={cta.href}
        target={cta.target}
        rel={cta.rel}
        disabled={false}
        className="inline-block"
        onClick={onClick}
        buttonClassName="w-fit rounded-full bg-yellow-500 hover:bg-yellow-600 py-2 px-8 font-bold"
      >
        {cta.text}
      </Button>
    </div>
  );
};

export default BottomCTAButton;
